import client from './client';

const API = process.env.REACT_APP_AUTH_API || '/api/auth';
const BASE = API.replace('/api/auth', '/api/plans');

export const getPlans = async () => {
    const res = await client.get(BASE);
    return res.data;
};

export const assignPlan = async (planId) => {
    const res = await client.post(`${BASE}/assign`, { planId });
    return res.data;
};
